import 'flowbite/dist/flowbite.css';
import './styles/index.css';

import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from 'react-query';
import { VersionProvider } from '@/versionStrategy';
import { queryClient } from '@/queryClient';
import App from './App';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!);

root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <VersionProvider>
        <App />
      </VersionProvider>
    </QueryClientProvider>
  </BrowserRouter>
);
